exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart_wrapper{width:100%;height:100%;position:relative;text-align:center}.chart_wrapper .highcharts_container{width:100%!important;height:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/usr/src/nuxt-app/assets","/static":"/usr/src/nuxt-app/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d6d63ec6","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/highchartsBarChart.vue
// module id = zH9k
// module chunks = 0 2